module.exports = __webpack_public_path__ + "static/media/bluelab-ph-pen.af9272bb.webp";